import { CtaButton, CtaButtonProps } from 'components/global/CtaButton';
import React from 'react';
import { LOCAL_COLORS } from 'styles/constants';

import { ReactComponent as Gift } from './images/gift.svg';

import {
  ContentContainer,
  Title,
  Subtitle,
  EfficacyStat,
  MainContainer,
  ImageContainer,
  InnerContainer,
  LeftBox,
  RightBox,
  ProdBanner,
  ctaStyles,
} from './LandingHeaderSqueeze.style';

const moduleName = 'landingHeader';

export interface LandingHeaderSqueezeProps {
  bannerText?: string;
  images?: JSX.Element;
  moduleName?: string;
  stats?: React.ReactNode[];
  subtitle?: string;
  title?: React.ReactNode;
  ctaButton?: CtaButtonProps;
  backgroundColor?: string;
}

export const LandingHeaderSqueeze = ({
  bannerText,
  images,
  title,
  stats,
  subtitle,
  ctaButton,
  backgroundColor = LOCAL_COLORS.surfaceDarkBold,
}: LandingHeaderSqueezeProps) => (
  <>
    {bannerText && (
      <ProdBanner>
        <Gift role="img" width={16} height={16} />
        <span>{bannerText}</span>
      </ProdBanner>
    )}
    <MainContainer data-module={moduleName}>
      <LeftBox />
      <InnerContainer>
        <ImageContainer backgroundColor={backgroundColor}>
          {images}
        </ImageContainer>
        <ContentContainer>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          {stats &&
            stats.map((stat, index) => {
              return <EfficacyStat key={index}>{stat}</EfficacyStat>;
            })}
          {ctaButton && <CtaButton {...ctaButton} css={ctaStyles} />}
        </ContentContainer>
      </InnerContainer>
      <RightBox />
    </MainContainer>
  </>
);
